import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class PasteClipboard {
  constructor(upload, element) {
    _defineProperty(this, "upload", void 0);
    this.upload = upload;
    element.addEventListener('paste', this.paste.bind(this));
  }
  paste(e) {
    var _e$clipboardData;
    if ((_e$clipboardData = e.clipboardData) != null && _e$clipboardData.items) {
      const items = e.clipboardData.items;
      const files = [];
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          if (file) {
            files.push(file);
          }
        }
      }
      if (files.length > 0) {
        e.preventDefault();
        this.upload(files);
      }
    }
  }
}
flarum.reg.add('fof-upload', 'forum/components/PasteClipboard', PasteClipboard);